module.exports = __webpack_public_path__ + "img/imgSeparator.dc5c9921.jpg";